import(/* @vite-ignore */ window.thComponentsUrl("/modules/tds-toaster.js")).then(({ showToast }) => {
  const DEFAULT_DURATION = 6000;

  const buildUnsafeMessage = (heading) => {
    const link = document.createElement('a');
    link.href = heading.href;
    link.text = heading.label;
    return link.outerHTML;
  }

  const TOAST_HTML_CONFIG = { ALLOWED_TAGS: ["a", "strong", "em", "br", "span"], ALLOWED_ATTR: ["style", "href", "target", "rel"] };

  // support inconsistent detail interface
  const transformDetail = (detail) => {
    let message = typeof(detail.heading) === 'string' ? detail.heading : null;
    let unsafeMessage = typeof(detail.heading) === 'object' ? buildUnsafeMessage(detail.heading[0]) : null;
    let duration = typeof(detail.duration) === 'undefined' ? DEFAULT_DURATION : detail.duration;

    return {
      variant: detail.variant,
      unsafeMessage: message ? message : unsafeMessage,
      htmlConfig: TOAST_HTML_CONFIG,
      duration: duration
    }
  }

  const summonToast = (e) => {
    const toastOptions = transformDetail(e.detail);

    showToast(toastOptions);
  }

  window.addEventListener('showToast', summonToast);

  // needed to support flash[:], see _toaster.html.erb
  if(window.flashEvents) {
    window.flashEvents();
  }
}).catch((error) => {
  // The toaster module is fetched at runtime from the cross-origin components
  // CDN (ui.trailhead.com). That fetch fails for a small tail of pageviews due
  // to transient network conditions, ad-blockers, corporate proxies, and
  // PNA/CORS enforcement — none of which we control. Without this handler the
  // rejection surfaces as an "Unhandled Promise Rejection" JS error (~30k/week)
  // that buries real errors. Notice it once with context so we keep visibility
  // into the true rate, then swallow it so toasts degrade gracefully.
  /*global newrelic*/
  if (typeof newrelic != "undefined") {
    newrelic.noticeError(error);
  } else {
    console.warn('Failed to load tds-toaster module; toasts are unavailable.', error);
  }
});
